import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { ReduxConnect } from "../../../toolkit/decorators/Artifact";
import Layout from "../../components/layout";
import BajaAppComponent from "../../components/totalPassBajaApp";
import { BajaAppStore, bajaAppStore } from "./BajaApp.store";
import { BajaAppDispatcher, bajaAppDispatcher } from "./BajaApp.dispatcher";

interface Props extends BajaAppStore, BajaAppDispatcher {}

/**
 * Baja de app TotalPass — Container
 * Pantalla: /total-pass/baja-app
 *
 * BFF: DELETE /api/total-pass/personas/{idPersona}/baja-app?userId={userId}
 * → ms-persona: DELETE /v1/total-pass/personas/{idPersona}/baja-app?userId={userId}
 */
@ReduxConnect(bajaAppStore, bajaAppDispatcher)
export default class BajaAppContainer extends Component<Props> {
  render() {
    return (
      <main>
        <Helmet title="Baja de app TotalPass" />
        <Layout headerLabel="Baja de app TotalPass">
          <BajaAppComponent
            bajaAppResult={this.props.bajaAppResult}
            postingBajaApp={this.props.postingBajaApp}
            postingBajaAppError={this.props.postingBajaAppError}
            userId={this.props.userId}
            deleteBajaAppTotalPass={this.props.deleteBajaAppTotalPass}
          />
        </Layout>
      </main>
    );
  }
}
